import React, { useEffect } from "react";

import { milktheframer } from "../../../utils/constants";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Milktheframer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section
        className={`bg-black px-8 pt-40 md:pt-60 -mt-[1px] text-center  lg:px-16 md:pb-10`}
      >
        <div className=" md:w-[80%] pb-12 text-left ">
          <h2
            className={`text-[32px] md:text-[64px] text-white leading-[33px] lg:leading-[74.56px] font-semibold `}
          >
            MILKYTHEFRAMER -
          </h2>
          <p
            className={`text-[32px] md:text-[64px] text-white leading-[33px] lg:leading-[74.56px]`}
          >
            Full Brand Design & Product designs for Framing brand
          </p>
        </div>
      </section>

      <section className="bg-black px-8 pb-12  -mt-[1px] lg:px-16 lg:pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="space-y-4 text-white">
            <h1 className="font-[400] text-[20px] leading-[30px] text-white/50 ">
              ABSTRACT
            </h1>
            <div className="h-[0.5px] bg-[#f5f5f5]" />
            <p className="font-[400] text-[20px] leading-[30px] ">
              A brand that provides top-class and luxurious frames deserves a
              fitting visual representation. With this project, I was able to
              express my familiarity with design. print, and interior-decor.
            </p>
          </div>

          <div className="space-y-4 text-white">
            <h1 className="font-[400] text-[20px] leading-[30px] text-white/50 ">
              SERVICE
            </h1>
            <div className="h-[0.5px] bg-[#f5f5f5]" />
            <p className="font-[400] text-[20px] leading-[30px] ">
              Brand Design + Advertising
            </p>
          </div>

          <div className="space-y-4 text-white">
            <h1 className="font-[400] text-[20px] leading-[30px] text-white/50 ">
              CREDITS
            </h1>
            <div className="h-[0.5px] bg-[#f5f5f5]" />
            <p className="font-[400] text-[20px] leading-[30px] ">
              Art Direction: Temidayo Arowolo
            </p>
          </div>
        </div>
      </section>

      <section className="bg-black px-8  -mt-[1px] lg:px-16 md:pb-10">
        {milktheframer.map((image) => (
          <div key={image.id} className="">
            <LazyLoadImage
              src={image.img}
              effect="blur"
              className="w-full pb-4"
              alt={image.id}
            />
          </div>
        ))}
      </section>

      <div className="bg-black px-8  -mt-[1px] lg:px-16 md:pb-10">
        <div className="h-[0.5px] bg-[#f5f5f5]" />
      </div>
    </>
  );
};

export default Milktheframer;
